const R2_EXERCISES_URL = "https://pub-3d7ad7f5d04d46a5b7232c0baf46d866.r2.dev/pronuncia-escrita.json";

let cachedExercises: any = null;

export const fetchExercises = async () => {
    if (cachedExercises) return cachedExercises;

    try {
        const response = await fetch(R2_EXERCISES_URL);
        if (!response.ok) throw new Error(`Failed to fetch exercises: ${response.status}`);
        cachedExercises = await response.json();
        return cachedExercises;
    } catch (error) {
        console.error("Error fetching exercises from R2:", error);
        throw error;
    }
};

export const getWritingExercises = async (langFolder: string, level: string) => {
    const data = await fetchExercises();
    const result = data?.escrita?.[langFolder]?.[level] || [];
    // Handle cases where JSON contains an object with numeric keys instead of an array (e.g. Dutch B1/B2)
    return Array.isArray(result) ? result : Object.values(result);
};

export const getPronunciationExercises = async (langFolder: string, level: string) => {
    const data = await fetchExercises();
    const result = data?.pronuncia?.[langFolder]?.[level] || [];
    // Handle cases where JSON contains an object with numeric keys instead of an array (e.g. Dutch B1/B2)
    return Array.isArray(result) ? result : Object.values(result);
};
